// extracted by mini-css-extract-plugin
export default {"wrapper":"quote-module--wrapper--2x4fm","quote":"quote-module--quote--1i7NL","author":"quote-module--author--HSIEo"};